import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  background-color: #ffffff;
  @media (max-width: 770px) {
    height: 100%;
    overflow-y: hidden;
    padding: 0;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  @media (max-width: 770px) {
    width: 100%;
    background-color: #ffffff;
  }
`;

export const NavigationContainer = styled.div`
  width: 100%;
  height: 80vh;
  padding: 0px 65px;
  overflow-y: scroll;
  display: flex;
  flex-flow: row wrap;

  @media (max-width: 770px) {
    width: 100%;
    height: calc(100% - calc(25vh + 111px));
    padding: 30px 5px;
    background-color: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  @media (max-width: 770px) and (max-height: 680px) {
    height: calc(100% - calc(35vh + 111px));
  }

  @media(min-width: 770px) and (max-width: 1400px) {
    padding: 0px 65px 15px 65px;
  }
`;

export const RefuelButton = styled(Link)`
  width: ${props => (props.hasStatus ? '33%' : '100%')};
  height: 40px;
  margin-top: 15px;
  margin-left: 1px;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  outline: none !important;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  padding: ${props => props.padding};
  &:hover {
    filter: brightness(90%);
  }
  span {
    color: #ffffff;
  }
  @media (max-width: 520px) {
    width: 100%;
  }
  @media (min-width: 855px) and (max-width: 975px) {
    font-size: 0.9rem;
  }
`;

export const RequestStatus = styled(Link)`
  width: 32%;
  height: 40px;
  margin-top: 20px;
  margin-rigth: 1px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #427cf7;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 10px;
  text-decoration: none !important;
  span {
    letter-spacing: 0px;
    font-weight: bold;
    color: #427cf7;
    font-family:"Roboto";
  }
  @media (max-width: 520px) {
    width: 100%;
  }
  img {
    fill: #427cf7;
  }
`;

export const CurrentStatus = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  span {
    letter-spacing: 0px;
    font-weight: bold;
    font-size: 12px;
    color: #427cf7;
  }
`;

export const CurrentStatusDate = styled.span`
  letter-spacing: 0px;
  font-size: 13px;
  font-weight: normal !important;
  color: #868686 !important;
`;

export const CurrentStatusBottomContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
  span {
    letter-spacing: 0px;
    font-size: 11.6px;
    font-weight: normal !important;
    color: #868686 !important;
    margin-left: 5px;
  }
`;

export const CurrentStatusCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: ${props => {
    if (
      props.status === 'AGUARDANDO ANÁLISE DO FINANCEIRO' ||
      props.status === 'EM ANÁLISE PELO FINANCEIRO' ||
      props.status ===
        'AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO' ||
      props.status ===
        'AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO'
    ) {
      return `#000FFF`;
    } else if (props.status === 'LIBERADO') {
      return `#00E309`;
    } else if (props.status === 'NÃO LIBERADO PELO FINANCEIRO') {
      return `#F7D100`;
    } else {
      return `#FD0000`;
    }
  }};
`;

export const TrainingsButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 770px) {
    display: none;
  }
`;

export const TrainingsButton = styled.button`
  width: 45%;
  height: 40px;
  margin-top: 20px;
  background: transparent 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  outline: none !important;
  border: 1px solid #000FFF;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000FFF;
  font-size: 14px;
  &:hover {
    background: #000FFF 0% 0% no-repeat padding-box;
    color: #ffffff;
  }
`;

export const EmployeesButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const EmployeesStatusContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 520px) {
    flex-direction: column;
  }
`;

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const DropdownItemEconomic = {
  paddingLeft: 10,
  paddingRight: 10,
};

export const DrodownButtonEconomic = {
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  padding: 0,
  borderWidth: 0,
  maxWidth: 300,
};

export const DropdownMenuEconomic = {
  maxHeight: 300,
  overflow: 'auto',
  marginTop: -15,
  borderBottomLeftRadius: 20,
  borderBottomRightRadius: 20,
  borderWidth: 0,
  boxShadow: '0px 18px 17px 3px #00000066',
  width: '100%',
};

export const SeccondModalButtons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`;

export const OrderContainerMobile = styled.div`
  display: none;
  @media (max-width: 770px) {
    width: 100%;
    display: flex;
  }
`;

export const OrderContainerWeb = styled.div`
  display: flex;

  @media (min-width: 770px) and (max-width: 875px) {
    width: 100%;
  }

  @media (max-width: 770px) {
    width: 100%;
    display: none;
  }
`;

export const IconStatusOrder = {
  transform: 'rotate(270deg)',
};

export const OrderMessageError = styled.span`
  color: #808080;
  font-family: 'Roboto';
`;

export const PendencyQuantity = styled.div`
  background: #F53832;
  border: 1.5px solid #FFF;
  border-radius: 8px;
  text-align: center;
  color: #FFF;
  width: 86px;
  position: relative;


  @media(min-width:1510px){
    transform: translate(290px, -95px);
  }

  @media(max-width:1509px){
    transform: translate(230px, -95px);
  }

  @media(max-width:1105px){
    transform: translate(210px, -95px);
  }

  @media(max-width:972px){
    transform: translate(160px, -95px);
  }

  @media(max-width:870px){
    transform: translate(475px, -60px);
  }

  @media(max-width:864px){
    transform: translate(455px, -60px);
  }

  @media(max-width:844px){
    transform: translate(435px, -60px);
  }

  @media(max-width:824px){
    transform: translate(415px, -60px);
  }

  @media(max-width:804px){
    transform: translate(395px, -60px);
  }

  @media(max-width:794px){
    transform: translate(385px, -60px);
  }

  @media(max-width:770px){
    transform: translate(525px, -60px);
  }

  @media(max-width:769px){
    transform: translate(625px, -60px);
  }

  @media(max-width:766px){
    transform: translate(615px, -60px);
  }

  @media(max-width:756px){
    transform: translate(605px, -60px);
  }

  @media(max-width:746px){
    transform: translate(595px, -60px);
  }

  @media(max-width:736px){
    transform: translate(585px, -60px);
  }

  @media(max-width:726px){
    transform: translate(575px, -60px);
  }

  @media(max-width:716px){
    transform: translate(565px, -60px);
  }

  @media(max-width:706px){
    transform: translate(555px, -60px);
  }

  @media(max-width:696px){
    transform: translate(545px, -60px);
  }

  @media(max-width:686px){
    transform: translate(535px, -60px);
  }

  @media(max-width:676px){
    transform: translate(525px, -60px);
  }

  @media(max-width:666px){
    transform: translate(515px, -60px);
  }

  @media(max-width:646px){
    transform: translate(505px, -60px);
  }

  @media(max-width:646px){
    transform: translate(495px, -60px);
  }

  @media(max-width:636px){
    transform: translate(485px, -60px);
  }

  @media(max-width:626px){
    transform: translate(475px, -60px);
  }

  @media(max-width:616px){
    transform: translate(465px, -60px);
  }

  @media(max-width:606px){
    transform: translate(455px, -60px);
  }

  @media(max-width:596px){
    transform: translate(445px, -60px);
  }

  @media(max-width:586px){
    transform: translate(435px, -60px);
  }

  @media(max-width:576px){
    transform: translate(425px, -60px);
  }

  @media(max-width:566px){
    transform: translate(415px, -60px);
  }

  @media(max-width:556px){
    transform: translate(405px, -60px);
  }

  @media(max-width:546px){
    transform: translate(395px, -60px);
  }

  @media(max-width:536px){
    transform: translate(385px, -60px);
  }

  @media(max-width:526px){
    transform: translate(375px, -60px);
  }

  @media(max-width:516px){
    transform: translate(365px, -60px);
  }

  @media(max-width:506px){
    transform: translate(355px, -60px);
  }

  @media(max-width:496px){
    transform: translate(345px, -60px);
  }

  @media(max-width:486px){
    transform: translate(335px, -60px);
  }

  @media(max-width:476px){
    transform: translate(325px, -60px);
  }

  @media(max-width:466px){
    transform: translate(315px, -60px);
  }

  @media(max-width:456px){
    transform: translate(305px, -60px);
  }

  @media(max-width:447px){
    transform: translate(295px, -60px);
  }

  @media(max-width:437px){
    transform: translate(285px, -60px);
  }

  @media(max-width:430px){
    transform: translate(285px, -65px);
  }

  @media(max-width:425px){
    transform: translate(275px, -65px);
  }

  @media(max-width:416px){
    transform: translate(265px, -65px);
  }

  @media(max-width:407px){
    transform: translate(255px, -65px);
  }

  @media(max-width:397px){
    transform: translate(245px, -65px);
  }

  @media(max-width:387px){
    transform: translate(235px, -65px);
  }

  @media(max-width:375px){
    transform: translate(225px, -65px);
  }

  @media(max-width:365px){
    transform: translate(215px, -65px);
  }

  @media(max-width:354px){
    transform: translate(205px, -65px);
  }

  @media(max-width:343px){
    transform: translate(195px, -65px);
  }

  @media(max-width:334px){
    transform: translate(185px, -65px);
  }

  @media(max-width:322px){
    transform: translate(175px, -65px);
  }

  @media(max-width:311px){
    transform: translate(165px, -65px);
  }

  @media(max-width:301px){
    transform: translate(155px, -65px);
  }

  @media(max-width:293px){
    transform: translate(145px, -65px);
  }
`

export const AreaBanner = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const AreaTwoCards = styled.div`
  // display: flex;
  // flex-direction: column;

  // @media(max-width: 1340px){
  //   display: none;
  // }

  display: flex;
  flex-direction: column;

  @media(max-width: 1200px){
    display: none;
  }
`;

export const AreaOthersCards = styled.div`
  // @media(min-width: 1339px){
  //   display: ${props => (props.slider ? 'none' : 'contents')};
  // }

  // @media(max-width: 870px){
  //   width: ${props => (props.order ? '100%' : '95%')};
  // }

  @media(min-width: 1199px){
    display: ${props => (props.slider ? 'none' : 'contents')};
  }

  @media(max-width: 870px){
    width: ${props => (props.order ? '100%' : '95%')};
  }
`;
